module.exports = __webpack_public_path__ + "50a7afec16f3a1cff5202f64044975f6.png";